import InvoiceSettings from "./InvoiceSettings";

export default function PaymentVerificationSettings() {
  return <InvoiceSettings variant="verification" />;
}
